import {UserWithdrawalReasonDomain} from "../../domain/user/UserWithdrawalReasonDomain"

export const UserWithdrawalReasonDescriptor: Record<keyof UserWithdrawalReasonDomain, (o: UserWithdrawalReasonDomain) => string> = {
    id(o: UserWithdrawalReasonDomain): string {
        return o.id.toString()
    },
    creatorId(o: UserWithdrawalReasonDomain): string {
        return o.creatorId.toString()
    },
    body(o: UserWithdrawalReasonDomain): string {
        return o.body
    },
    displayOrder(o: UserWithdrawalReasonDomain): string {
        return o.displayOrder.toString()
    },
    userWithdrawalCount(o: UserWithdrawalReasonDomain): string {
        return o.userWithdrawalCount.toString()
    },
    createdAt(o: UserWithdrawalReasonDomain): string {
        return o.createdAt.toISOString().substring(0, 19).replace('T', ' ')
    },
    lastModifiedAt(o: UserWithdrawalReasonDomain): string {
        return o.lastModifiedAt?.toISOString().substring(0, 19).replace('T', ' ') ?? '-'
    },
    concealedAt(o: UserWithdrawalReasonDomain): string {
        return o.concealedAt?.toISOString().substring(0, 19).replace('T', ' ') ?? '-'
    }
}
